import React, {useState} from 'react';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const NetworkEngineerFilter = ({
                                   applyFilter,
                                   roleId
                               }) => {
    const filterInputs = {
        client_name: ''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    console.log('Client-Filter');
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
            }}
        >
            <ConstantInput
                label={localization.clientNameFilter}
                value={filterFieldsData.client_name}
                regex={Regex.text.test(filterFieldsData.client_name)}
                type="text"
                handleChange={(val) =>
                    setFilterFieldsData({...filterFieldsData, client_name: val})
                }
            />

            <br/>
            <br/>
            <br/>
            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src="../images/arrow-right.png" alt=""/>
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        applyFilter(filterInputs);
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default NetworkEngineerFilter;
